module.exports = __webpack_public_path__ + "images/img_61.png";